window.CardSlider = () => {
	return {
		swiper: null,
		init() {
			setTimeout(() => {
				// Inner blocks render as plain wrapper divs; Swiper only treats .swiper-slide children as slides
				this.$refs.wrapper
					.querySelectorAll(':scope > div')
					.forEach((el) => el.classList.add('swiper-slide'));

				this.swiper = new Swiper(this.$refs.container, {
					slidesPerView: 1,
					spaceBetween: 32,
					grabCursor: true,
					a11y: true,
					navigation: {
						prevEl: this.$refs.prev,
						nextEl: this.$refs.next,
					},
					pagination: {
						el: this.$refs.counter,
						type: 'fraction',
					},
					// ⚠ Swiper eats part of the gap from a fractional view; .27 leaves ~21% of the next card visible (Figma)
					breakpoints: {
						768: { slidesPerView: 2.27 },
						1280: { slidesPerView: 3.27 },
					},
				});
			}, 0);
		},
	};
};
